import React from 'react';
import Tag, { TagType } from '../components/Tag';
import { useABTests } from 'hooks/useABTests';
import { AddLastUpdateToWeights } from 'config/abTests';
import { daysFrom } from 'helpers/dateUtils';
import { UnitRelevancy, getRelevancy } from 'components/unit-page/RelevancyLabel';
import { State } from 'store/state';
import { PoiId, DealType, MarketplaceType } from 'utils/entities';
import { connect, useSelector } from 'react-redux';
import config from 'config';
import { ISOString } from 'locale/formatDate';
import { isInLastViewedSelector } from 'store/state/selectors/poi';
import { ViewedLabelWrapper } from 'ds/components/ListingCard';
import ViewedIcon from 'assets/svg/viewed.svg';
import { useLocale } from 'locale';
import { marketplaceSelector } from 'store/state/selectors/router';

interface ListingTagsProps {
  hasPriceDrop: boolean;
  inSearchArea: boolean;
  lastUpdatedDate: ISOString;
  createdDate: ISOString;
  isInLastViewed?: boolean;
  dealType: DealType;
  id: PoiId;
}

const ListingTags: React.FC<ListingTagsProps> = (props) => {
  const { hasPriceDrop, lastUpdatedDate, createdDate, isInLastViewed, dealType, inSearchArea } = props;
  const relevancy = getRelevancy({ createdDate, isInLastViewed, isBulletinType: true, dealType });
  const { _be_addLastUpdateToWeights } = useABTests();
  const isModeB = _be_addLastUpdateToWeights === AddLastUpdateToWeights.modeB;
  const isUpdated = new Date(lastUpdatedDate).getTime() !== new Date(createdDate).getTime();
  const passedUpdateDays = lastUpdatedDate ? daysFrom(new Date(lastUpdatedDate)) : null;
  const marketplace = useSelector(marketplaceSelector);
  const isRecentlyViewedV2 = marketplace === MarketplaceType.Residential;
  const { t } = useLocale();

  if (isRecentlyViewedV2 && isInLastViewed) {
    return (
      <ViewedLabelWrapper>
        <ViewedIcon />
        {t('unitPage.dateLabel.viewed')}
      </ViewedLabelWrapper>
    );
  }

  if (inSearchArea) return <Tag data-auto="date-label" type={TagType.InSearchArea} />;
  if (!config.daysInMarket[dealType]) return null;

  if (hasPriceDrop) {
    return <Tag data-auto="date-label" type={TagType.PriceDrop} />;
  }
  else if (isModeB && isUpdated && passedUpdateDays === 0) {
    return <Tag data-auto="date-label" type={TagType.UpdatedToday} />;
  }
  else if (relevancy === UnitRelevancy.New) {
    return <Tag data-auto="date-label" type={TagType.New} />;
  }

  return null;
};

const mapStateToProps = (state: State, props: ListingTagsProps) => ({
  isInLastViewed: isInLastViewedSelector(state, props.id),
});

export default connect(mapStateToProps)(ListingTags);
